// dependencies
import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components
import User from "./components/User";
import Paginator from "Components/Paginator";

// actions
import { init, fetchPageData, changePage } from "./actions";

// selectors
import { getIsRequesting } from "Selectors/app";
import { getRecentUsers, getRecentUsersPageCount, getCurrentPage, getRecentUsersCount } from "./selectors";

// css
import css from "./Recent";

class RecentUsersPage extends React.PureComponent {
	static propTypes = {
		isRequesting: PropTypes.bool.isRequired,
		init: PropTypes.func.isRequired,
		fetchPageData: PropTypes.func.isRequired,
		changePage: PropTypes.func.isRequired,
		environment: PropTypes.string.isRequired,
		currentPage: PropTypes.number.isRequired,
		recentUsersPageCount: PropTypes.number.isRequired,
		recentUsersCount: PropTypes.number.isRequired,
		recentUsers: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	componentDidMount = () => {
		this.props.init();
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.environment !== this.props.environment) {
			this.props.fetchPageData();
		}
	};

	changePage = (page) => {
		this.props.changePage(page);
	};

	render = () => {
		const { currentPage, recentUsersPageCount, recentUsers, recentUsersCount, isRequesting } = this.props;

		return (
			<div className={css.RecentUsersPageContainer}>
				<div className={css.pageHead}>
					<div className={css.pageTitle}>Recent Users</div>
					<div className={css.subTitle}>{`${recentUsersCount} total users.`}</div>
				</div>

				<div className={css.recentUsersList}>
					{recentUsers.map((user) => (
						<User key={user.get("id")} user={user} />
					))}
				</div>

				<div className={css.paginatorWrapper}>
					<Paginator
						isRequesting={isRequesting}
						onClick={this.changePage}
						pageCount={recentUsersPageCount}
						currentPage={currentPage}
					/>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	currentPage: getCurrentPage(state),
	recentUsers: getRecentUsers(state),
	recentUsersCount: getRecentUsersCount(state),
	recentUsersPageCount: getRecentUsersPageCount(state),
	isRequesting: getIsRequesting(state, "USERS:RECENT"),
});

const mapDispatchToProps = (dispatch) => ({
	fetchPageData: () => dispatch(fetchPageData()),
	changePage: (page) => dispatch(changePage(page)),
	init: (graphWidth) => dispatch(init(graphWidth)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecentUsersPage);
